import { DocumentoCard } from './DocumentoCard.js'
import { DocumentoRow } from './DocumentoRow.js'
import { EmptyPanel } from '@components/primitives/EmptyPanel.js'
import { NavIcon } from '@components/layout/NavIcons.js'
import type { DocItem, ViewMode } from './types.js'

type Props = {
  filtered: DocItem[]
  totalCount: number
  viewMode: ViewMode
  onEdit: (doc: DocItem) => void
  onDelete: (doc: DocItem) => void
  onPreview: (doc: DocItem) => void
  onNew?: () => void
  onClearFilters?: () => void
}

export function DocumentosContent({
  filtered,
  totalCount,
  viewMode,
  onEdit,
  onDelete,
  onPreview,
  onNew,
  onClearFilters,
}: Props) {
  return (
    <section className='cf3-block'>
      {filtered.length === 0 ? (
        totalCount === 0 ? (
          <EmptyPanel
            icon={<NavIcon icon='documentos' size={24} />}
            title='Nenhum arquivo ainda'
            description='Guarde contratos, notas fiscais e projetos da obra em um só lugar, acessível offline.'
            {...(onNew ? { actionLabel: 'Adicionar documento', onAction: onNew } : {})}
          />
        ) : (
          <EmptyPanel
            title='Nenhum resultado'
            description='Nenhum documento corresponde a este filtro.'
            {...(onClearFilters ? { actionLabel: 'Limpar filtros', onAction: onClearFilters } : {})}
          />
        )
      ) : viewMode === 'gallery' ? (
        <div className='cf3-doc-gallery' aria-label='Galeria de documentos'>
          {filtered.map((doc) => (
            <DocumentoCard
              key={doc.id}
              doc={doc}
              onEdit={() => onEdit(doc)}
              onDelete={() => onDelete(doc)}
              onPreview={() => onPreview(doc)}
            />
          ))}
        </div>
      ) : (
        <div className='cf3-doc-list' role='list' aria-label='Lista de documentos'>
          {filtered.map((doc) => (
            <DocumentoRow
              key={doc.id}
              doc={doc}
              onEdit={() => onEdit(doc)}
              onDelete={() => onDelete(doc)}
              onPreview={() => onPreview(doc)}
            />
          ))}
        </div>
      )}
    </section>
  )
}
